<template>
  <component-page :code-view="codeView">
    <template #description> </template>
    <template #component>
      <r-paginator v-bind="props" v-model="model"  @update:perPage="onPerPageChange" />
    </template>
    <template #props>
      <r-row gap-hidden class="d-flex align-items-center">
        <div class="prop-control">
          <span class="mb-2 troy--text parmigiano">countPage</span>
          <r-input-number v-model="props.countPage" />
        </div>
        <div class="prop-control">
          <span class="mb-2 troy--text parmigiano">totalPage</span>
          <r-input-number :min="7" v-model="props.totalPage" />
        </div>
        <div class="prop-control">
          <r-switcher
            v-model="props.showGotoPage"
            :disabled="false"
            :error="false"
            title="showGotoPage"
            :subTitle="null"
            :errorMessage="null"
            :notShorter="false"
          />
        </div>

        <div class="prop-control">
          <r-switcher v-model="props.showPerPageSelector" title="showPerPageSelector" />
        </div>
        <div class="prop-control">
          <r-switcher v-model="props.showTotalItems" title="showTotalItems" />
        </div>
        <div class="prop-control">
          <r-input v-model="props.labelPerPage" label="labelPerPage" />
        </div>
        <div class="prop-control">
          <r-input v-model="props.labelTotalItems" label="labelTotalItems" />
        </div>
      </r-row>
    </template>
    <template #api>
      <div class="taleggio mb-8">Props</div>
      <r-table class="mb-8" :headers="headersProps" :items="itemsProps">
        <template #nameProp="{ item }">
          <div v-html="item.nameProp" />
        </template>
        <template #typeData="{ item }">
          <div v-html="item.typeData" />
        </template>
        <template #defaultValue="{ item }">
          <div v-html="item.defaultValue" />
        </template>
        <template #showGotoPage="{ item }">
          <div v-html="item.showGotoPage" />
        </template>
      </r-table>
      <div class="taleggio mb-8">Events</div>
      <r-table class="mb-8" :headers="headersEvents" :items="itemsEvents">
        <template #nameEvent="{ item }">
          <div v-html="item.nameEvent" />
        </template>
        <template #description="{ item }">
          <div v-html="item.description" />
        </template>
      </r-table>
    </template>
  </component-page>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-javascript";
import { generateCodeToString } from "@/utils/markupCode";
import ComponentPage from "@/layouts/ComponentPage.vue";

@Component({
  components: { ComponentPage },
})
export default class Paginator extends Vue {
  headersProps = [
    {
      field: "nameProp",
      name: "Название параметра",
      description: "Наименование входного параметра",
      slot: true,
    },
    {
      field: "typeData",
      name: "Тип данных",
      description: "Применение входного параметра с типом данных",
      slot: true,
    },
    {
      field: "defaultValue",
      name: "Значение по умолчанию",
      slot: true,
    },
    {
      field: "description",
      name: "Описание",
      description: "Описание входного параметра",
    },
  ];

  headersEvents = [
    {
      field: "nameEvent",
      name: "Наименование события",
      description: "Наименование события в компоненте",
      slot: true,
    },
    {
      field: "description",
      name: "Описание",
      description: "Описание входного параметра",
    },
  ];

  itemsProps = [
    {
      nameProp: '<span class="rocky--text">value</span>',
      typeData: '<span class="matrix--text">number</span>',
      defaultValue: '<span class="alien--text">undefined</span>',
      description: "Модель выбранного значения",
    },
    {
      nameProp: '<span class="rocky--text">countPage</span>',
      typeData: '<span class="matrix--text">number</span>',
      defaultValue: '<span class="fargo--text">Обязательный параметр</span>',
      description: "Количество страниц",
    },
    {
      nameProp: '<span class="rocky--text">totalPage</span>',
      typeData: '<span class="matrix--text">number</span>',
      defaultValue: '<span class="fargo--text">Обязательный параметр</span>',
      description:
        "Количество отображаемых элементов в нумерации (учитываются первая страница, последняя страница и троеточия), при этом минимальное количество элементов должно быть 7 (если указано значение меньше 7, оно игнорируется)",
    },
    {
      nameProp: '<span class="rocky--text">showGotoPage</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: "Переход на указанную страницу",
    },
    {
      nameProp: '<span class="rocky--text">showPerPageSelector</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: "Показывать селектор количества элементов на странице",
    },
    {
      nameProp: '<span class="rocky--text">perPageOptions</span>',
      typeData: '<span class="matrix--text">number[]</span>',
      defaultValue: '<span class="alien--text">[10,20,50,100]</span>',
      description: 'Список опций для селектора "Показывать по"',
    },
    {
      nameProp: '<span class="rocky--text">perPage</span>',
      typeData: '<span class="matrix--text">number</span>',
      defaultValue: '<span class="alien--text">10</span>',
      description: 'Текущее значение "Показывать по"',
    },
    {
      nameProp: '<span class="rocky--text">showTotalItems</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: "Показывать общее число элементов",
    },
    {
      nameProp: '<span class="rocky--text">totalItems</span>',
      typeData: '<span class="matrix--text">number</span>',
      defaultValue: '<span class="alien--text">0</span>',
      description: "Общее число элементов для отображения",
    },
    {
      nameProp: '<span class="rocky--text">labelPerPage</span>',
      typeData: '<span class="matrix--text">string</span>',
      defaultValue: '<span class="alien--text">Показывать по</span>',
      description: 'Текст перед селектором "Показывать по"',
    },
    {
      nameProp: '<span class="rocky--text">labelTotalItems</span>',
      typeData: '<span class="matrix--text">string</span>',
      defaultValue: '<span class="alien--text">Всего</span>',
      description: "Текст перед отображением общего числа элементов",
    },
  ];

  itemsEvents = [
    {
      nameEvent: '<span class="rocky--text">input</span>',
      description: "Возвращается состояние модели компонента",
    },
    {
      nameEvent: '<span class="rocky--text">update:perPage</span>',
      description: "Вызывается при выборе нового количества элементов",
    },
  ];

  model = 1;

  props = {
    countPage: 9,
    totalPage: 7,
    showGotoPage: true,
    showPerPageSelector: true,
    perPageOptions: [5, 10, 15],
    perPage: 5,
    showTotalItems: true,
    totalItems: 0,
    labelPerPage: "Показывать по",
    labelTotalItems: "Всего",
  };

  onPerPageChange(newPerPage: number) {
    this.props.perPage = newPerPage;
  }

  get codeView() {
    return generateCodeToString("paginator", this.props);
  }
}
</script>

<style lang="scss" scoped>
.component {
  &__view {
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.prop-control {
  display: flex;
  flex-direction: column;
  min-width: 160px;
  margin-bottom: 16px;
}
</style>
